import { currencySymbol, Currency } from './currency'
import moment, { Moment } from 'moment'
import daysjs from 'dayjs'
import * as scheduleDurationHelper from './scheduleDurationHelper'

export const currencyFormatterOld = (priceCurrency: Currency, amount?: number) => {
  return `${currencySymbol(priceCurrency)}${amount !== null && amount !== undefined ? amount : ''}`
}

export const currencyFormatter = (priceCurrency: Currency, amount: number | undefined, minimumFractionDigits = 2) => {
  if (!amount) return ''

  return new Intl.NumberFormat(undefined, { style: 'currency', currency: priceCurrency, minimumFractionDigits }).format(
    amount
  ).replace('CA$', '$')
}

export const computeDuration = (startAt: Moment, endAt: Moment, durationUnit: number, timezone?: string): number => {
  return scheduleDurationHelper.computeDuration(daysjs(startAt.valueOf()), daysjs(endAt.valueOf()), durationUnit, timezone)
}

export const formatDuration = (duration: number, durationUnit: number, filterOne = false): string => {
  return scheduleDurationHelper.formatDuration(duration, durationUnit, filterOne)
}

export const computeEndDate = (startAt: Moment, duration: number, durationUnit: number): Moment => {
  return moment(scheduleDurationHelper.computeEndDate(daysjs(startAt.valueOf()), duration, durationUnit).toDate())
}

